import { Vehicle } from '@/entity/vehicle/vehicle'
import { VehicleModel } from '../../entity/vehicle/model';
import { VehicleType } from '../../entity/vehicle/type';
import { VehicleMake } from '../../entity/vehicle/make';
import { VehicleChargeSocketType } from '../../entity/vehicle/charge-socket-type';
import { VehicleStatus } from '@/entity/vehicle/vehicle-status';

export class EVehicleTransformer {
    
    transform(vehicleInfo: any): Vehicle {
        let vehicleTypeInfo = vehicleInfo.type
        let vehicleMakeInfo = vehicleInfo.make
        let vehicleModelInfo = vehicleInfo.model
        let vehicleChargerSocketTypeInfo = vehicleInfo.socketType
        let statusInfo = vehicleInfo.status           
        return new Vehicle(
            vehicleInfo.vehicleId,
            new VehicleType(vehicleTypeInfo.code, vehicleTypeInfo.description),
            new VehicleMake(vehicleMakeInfo.code, vehicleMakeInfo.description),
            new VehicleModel(vehicleModelInfo.code, vehicleModelInfo.description),
            vehicleInfo.vehicleRegNo,
            vehicleInfo.onboardPower,
            /** */
            // new VehicleChargeSocketType(vehicleChargerSocketTypeInfo.code, vehicleChargerSocketTypeInfo.description),
            new VehicleChargeSocketType("", ""),
            /** */
            vehicleInfo.YOM,
            new VehicleStatus(statusInfo.code, statusInfo.description),
            vehicleInfo.bookingCount,
        )
    }

    deTransform(vehicle: Vehicle): any {
        let vehicleInfo = {}
        if (vehicle.id) {
            vehicleInfo = {
                vehicleId: vehicle.id,
                ...vehicleInfo
            }
        }
        vehicleInfo = {
            ...vehicleInfo,
            type: {
                code: vehicle.type.id
            },
            make: {
                code: vehicle.make.id
            },
            model: {
                code: vehicle.model.id
            },
            socketType: {
                /** */
                // code: vehicle.socketType.id
                /** */
                code: ""
            },
            vehicleRegNo: vehicle.regNo,
            onboardPower : vehicle.onboardPower,
            YOM: vehicle.yearOfManufacturing,
        }
        return vehicleInfo
    }
}